import { StateCreator } from 'zustand';

import { type Store } from '~/src/store/types';

interface BasketStore {
  basketId: Nullable<string>;
  setBasketId: (basketId: Nullable<string>) => void;
}

const createBasketStoreSlice: StateCreator<Store, [], [], BasketStore> = (
  set
) => ({
  basketId: null,
  setBasketId: (basketId) => set(() => ({ basketId })),
});

export { createBasketStoreSlice };
export type { BasketStore };
